import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Globals, Constants, Permissions } from 'utils';
import { performLogout } from 'utils/logout';
import Header from './header';
import $ from 'jquery';
import { Logo } from 'assets/img';
import {
  ArrowUp,
  ArrowBottom,
  Menu as MenuIcons,
  MenuIcon,
  ChatAIIcon,
  SurveysIcon,
  LockIcon,
  UserCircleIcon,
  LogoutMenuIcon,
  HistoryIcon,
  ReferralWithdrawalIcon,
  GiftIcon,
} from 'assets/icons';
import { Modal } from 'components';
import ModalViewValidate from './lawyer/home/modal-validation';
import ModalWelcomeLawyer from './lawyer/home/modal-welcome';
import ModalWelcomeClient from './client/home/modal-welcome';
import { ServiceService } from 'services';

declare var window: any;

interface MenuItem {
  name: string;
  path: string;
  submenu?: MenuItem[];
  icon?: string;
  permission?: string;
  onClick?: () => void;
  iconActive?: string;
  code: string;
  isLogout?: boolean;
  disabled?: boolean;
  service_id?: number;
  /** Si es true, el ítem se muestra con candado y no es clickeable
   * cuando el abogado no tiene membresía activa. Usa this.props.plan_user
   * (ya disponible por Redux) para determinarlo. */
  requiresMembership?: boolean;
  /** Si es true, el ítem se muestra bloqueado (candado) y al hacer click
   * muestra un mensaje fijo de "no disponible por el momento", sin
   * depender de service_id ni de la membresía. Se usa para ocultar
   * temporalmente una funcionalidad ya construida (ej: Firma Electrónica)
   * sin afectar el conteo del servicio dentro de la membresía. */
  forceDisabled?: boolean;
}

class Menu extends React.Component<any> {
  state: any = {
    leftOpen: this.props.sidebar,
    openResponsive: false,
    visibleVerifyModal: false,
    visibleWelcomeClientModal: false,
    visibleWelcomeModal: false,
    visibleUpdateDocsBanner: false,
    services_access: {} as Record<number, number>,
    items: [
      {
        name: 'Inicio',
        path: '/admin/home',
        icon: MenuIcons.Menu1,
        iconActive: MenuIcons.Menu1,
      },
      {
        name: 'Mi Perfil',
        path: '/profile',
        icon: UserCircleIcon,
        iconActive: UserCircleIcon,
      },
      {
        name: 'Usuarios',
        path: '/admin/users',
        icon: MenuIcons.Menu2,
        iconActive: MenuIcons.Menu2,
        permission: Constants.MODULES.USERS,
      },
      {
        name: 'Configuraciones',
        path: '/admin/services',
        icon: MenuIcons.Menu3,
        iconActive: MenuIcons.Menu3,
        permission: Constants.MODULES.SERVICES,
      },
      {
        name: 'Documentos',
        path: '/admin/documents',
        icon: MenuIcons.Menu13,
        iconActive: MenuIcons.Menu13,
        permission: Constants.MODULES.DOCUMENTS,
      },
      {
        name: 'Membresías',
        path: '/admin/memberships',
        icon: MenuIcons.Menu4,
        iconActive: MenuIcons.Menu4,
        permission: Constants.MODULES.MEMBERSHIPS,
      },
      {
        name: 'Trámites Automatizados',
        path: '/admin/formalities',
        icon: MenuIcons.Menu5,
        iconActive: MenuIcons.Menu5,
        permission: Constants.MODULES.FORMALITIES,
      },
      {
        name: 'Revisión Documental',
        path: '/admin/revision',
        icon: MenuIcons.Menu6,
        iconActive: MenuIcons.Menu6,
        permission: Constants.MODULES.REVISION,
      },
      {
        name: 'Firma Electrónica',
        path: '/admin/signature',
        icon: MenuIcons.Menu7,
        iconActive: MenuIcons.Menu7,
        permission: Constants.MODULES.SIGNATURE,
      },
      {
        name: 'Calificación',
        path: '/admin/ratings',
        icon: MenuIcons.Menu8,
        iconActive: MenuIcons.Menu8,
        permission: Constants.MODULES.RATINGS,
      },
      {
        name: 'Guías y Tutoriales',
        path: '/admin/guides',
        icon: MenuIcons.Menu9,
        iconActive: MenuIcons.Menu9,
        permission: Constants.MODULES.GUIDES,
      },
      {
        name: 'Chat',
        path: '/admin/chat',
        icon: MenuIcons.Menu10,
        iconActive: MenuIcons.Menu10,
        permission: Constants.MODULES.CHAT,
      },
      {
        // "Comunicados" -- mismo nombre que usa el backend para este módulo (ver
        // MODULES.NOTIFICATIONS y el checklist de permisos del moderador).
        name: 'Comunicados',
        path: '/admin/notifications',
        icon: MenuIcons.Menu16,
        iconActive: MenuIcons.Menu16,
        permission: Constants.MODULES.NOTIFICATIONS,
      },
      {
        name: 'Reportes',
        path: '/admin/reports',
        icon: MenuIcons.Menu11,
        iconActive: MenuIcons.Menu11,
        permission: Constants.MODULES.REPORTS,
        submenu: [
          { name: 'Pagos de membresías', path: '/admin/reports/payments' },
          {
            name: 'Pagos de servicios',
            path: '/admin/reports/services-payments',
          },
          {
            name: 'Comisiones/Pagos Recibidos',
            path: '/admin/reports/comissions',
          },
          {
            name: 'Pagos de paquetes',
            path: '/admin/reports/package-payments',
          },
        ],
      },
      {
        name: 'Llamadas Teléfonicas',
        path: '/admin/calls',
        icon: MenuIcons.Menu12,
        iconActive: MenuIcons.Menu12,
        permission: Constants.MODULES.CALLS,
      },
      {
        name: 'Elaboración Documental',
        path: '/admin/preparation',
        icon: MenuIcons.Menu15,
        iconActive: MenuIcons.Menu15,
        permission: Constants.MODULES.PREPARATION,
      },
      {
        name: 'Analytics',
        path: '/admin/analytics',
        icon: HistoryIcon,
        iconActive: HistoryIcon,
      },
      {
        name: 'Retiros de Referidos',
        path: '/admin/referrals',
        icon: ReferralWithdrawalIcon,
        iconActive: ReferralWithdrawalIcon,
        code: 'referrals',
      },
      {
        name: 'Cerrar Sesión',
        path: '#',
        icon: LogoutMenuIcon,
        iconActive: LogoutMenuIcon,
        isLogout: true,
        onClick: () => this.handleLogout(),
      },
    ],
    items_clients: [
      {
        name: 'Inicio',
        path: '/client/home',
        icon: MenuIcons.Menu1,
        iconActive: MenuIcons.Menu1,
      },
      {
        name: 'Mi Perfil',
        path: '/profile',
        icon: UserCircleIcon,
        iconActive: UserCircleIcon,
      },
      {
        name: 'Membresías',
        path: '/client/memberships',
        icon: MenuIcons.Menu4,
        iconActive: MenuIcons.Menu4,
        disabled: false,
      },
      {
        name: 'Elaboración documental',
        path: '/client/preparation',
        icon: MenuIcons.Menu15,
        iconActive: MenuIcons.Menu15,
        disabled: false,
        // Sin service_id: el acceso ya no se bloquea desde el menú.
        // Todo usuario puede entrar (paga fee si no tiene membresía).
      },
      {
        name: 'Revisión documental',
        path: '/client/revision',
        icon: MenuIcons.Menu6,
        iconActive: MenuIcons.Menu6,
        disabled: false,
        // Sin service_id: el acceso ya no se bloquea desde el menú.
        // Todo usuario puede entrar (paga fee si no tiene membresía).
      },
      {
        name: 'Consulta un abogado',
        path: '/client/chat',
        icon: MenuIcons.Menu10,
        iconActive: MenuIcons.Menu10,
        disabled: false,
      },
      {
        name: 'Llamadas Teléfonicas',
        path: '/client/calls',
        icon: MenuIcons.Menu12,
        iconActive: MenuIcons.Menu12,
        disabled: false,
      },
      {
        name: 'Firma electrónica',
        path: '/client/signatures',
        icon: MenuIcons.Menu7,
        iconActive: MenuIcons.Menu7,
        disabled: false,
        service_id: Constants.SERVICES.SIGN,
      },
      {
        name: 'Chat IA',
        path: '/client/ia-chat',
        icon: ChatAIIcon,
        iconActive: ChatAIIcon,
        disabled: false,
        service_id: Constants.SERVICES.BOTPRESS_CHAT,
      },
      {
        name: 'Trámites Automatizados',
        path: '/client/formalities',
        icon: MenuIcons.Menu5,
        iconActive: MenuIcons.Menu5,
        disabled: false,
        service_id: Constants.SERVICES.FORMALITIES,
      },
      {
        name: 'Calificaciones',
        path: '/client/surveys',
        icon: SurveysIcon,
        iconActive: SurveysIcon,
        disabled: false,
      },
      {
        name: 'Reportes',
        path: '/client/reports',
        icon: MenuIcons.Menu11,
        iconActive: MenuIcons.Menu11,
        disabled: false,
      },
      {
        name: 'Guías y Tutoriales',
        path: '/client/guides',
        icon: MenuIcons.Menu9,
        iconActive: MenuIcons.Menu9,
        disabled: false,
      },
      {
        name: 'Mis Referidos',
        path: '/client/referrals',
        icon: GiftIcon,
        iconActive: GiftIcon,
        disabled: false,
        code: 'referrals-client',
      },
      {
        name: 'Cerrar Sesión',
        path: '#',
        icon: LogoutMenuIcon,
        iconActive: LogoutMenuIcon,
        isLogout: true,
        onClick: () => this.handleLogout(),
      },
    ],
    items_lawyer: [
      {
        name: 'Inicio',
        path: '/lawyer/home',
        icon: MenuIcons.Menu1,
        iconActive: MenuIcons.Menu1,
      },
      {
        name: 'Mi Perfil',
        path: '/profile',
        icon: UserCircleIcon,
        iconActive: UserCircleIcon,
      },
      {
        name: 'Membresías',
        path: '/lawyer/memberships',
        icon: MenuIcons.Menu4,
        iconActive: MenuIcons.Menu4,
        disabled: false,
      },
      {
        name: 'Servicios',
        path: '/lawyer/services',
        icon: MenuIcons.Menu14,
        iconActive: MenuIcons.Menu14,
        disabled: false,
        requiresMembership: true,
      },
      {
        name: 'Elaboración de documento',
        path: '/lawyer/preparation',
        icon: MenuIcons.Menu15,
        iconActive: MenuIcons.Menu15,
        disabled: false,
        // Sin service_id: abogados internos siempre tienen acceso.
        // Para externos, el acceso se controla dentro de la pantalla.
      },
      {
        name: 'Revisión documental',
        path: '/lawyer/revision',
        icon: MenuIcons.Menu6,
        iconActive: MenuIcons.Menu6,
        disabled: false,
        // Sin service_id: abogados internos siempre tienen acceso.
        // Para externos, el acceso se controla dentro de la pantalla.
      },
      {
        name: 'Chat',
        path: '/lawyer/chat',
        icon: MenuIcons.Menu10,
        iconActive: MenuIcons.Menu10,
        disabled: false,
      },
      {
        name: 'Llamadas Teléfonicas',
        path: '/lawyer/calls',
        icon: MenuIcons.Menu12,
        iconActive: MenuIcons.Menu12,
        disabled: false,
        service_id: Constants.SERVICES.CALL,
      },
      {
        name: 'Firma electrónica',
        path: '/lawyer/signatures',
        icon: MenuIcons.Menu7,
        iconActive: MenuIcons.Menu7,
        disabled: false,
        service_id: Constants.SERVICES.SIGN,
      },
      {
        name: 'Chat IA',
        path: '/lawyer/ia-chat',
        icon: ChatAIIcon,
        iconActive: ChatAIIcon,
        disabled: false,
        service_id: Constants.SERVICES.BOTPRESS_CHAT,
      },
      {
        name: 'Trámites Automatizados',
        path: '/lawyer/formalities',
        icon: MenuIcons.Menu5,
        iconActive: MenuIcons.Menu5,
        disabled: false,
        service_id: Constants.SERVICES.FORMALITIES,
      },
      {
        name: 'Reportes',
        path: '/lawyer/reports',
        icon: MenuIcons.Menu11,
        iconActive: MenuIcons.Menu11,
        disabled: false,
      },
      {
        name: 'Guías y Tutoriales',
        path: '/lawyer/guides',
        icon: MenuIcons.Menu9,
        iconActive: MenuIcons.Menu9,
        disabled: false,
      },
      {
        name: 'Mis Referidos',
        path: '/lawyer/referrals',
        icon: GiftIcon,
        iconActive: GiftIcon,
        disabled: false,
        code: 'referrals-lawyer',
      },
      {
        name: 'Cerrar Sesión',
        path: '#',
        icon: LogoutMenuIcon,
        iconActive: LogoutMenuIcon,
        isLogout: true,
        onClick: () => this.handleLogout(),
      },
    ],
  };

  componentDidMount() {
    this.checkVerifyModal();
    this.loadServices();
  }

  componentDidUpdate(prevProps: any) {
    const prevWelcome = new URLSearchParams(prevProps.history.location.search).get('welcome');
    const currWelcome = new URLSearchParams(this.props.history.location.search).get('welcome');

    if (
      prevProps.user?.verified !== this.props.user?.verified ||
      prevWelcome !== currWelcome ||
      (!prevProps.user && this.props.user)
    ) {
      this.checkVerifyModal();
    }

    // Recargar accesos de servicios cuando se compra/renueva una membresía
    if (prevProps.plan_user !== this.props.plan_user && this.props.plan_user) {
      this.loadServices();
    }
  }

  loadServices = async () => {
    try {
      const res: any = await ServiceService.getStatus({
        user_id: this.props.user?.id,
      });

      const services_access: Record<number, number> = {};
      (res?.services || []).forEach((s: any) => {
        services_access[s.id] = s.access;
      });

      this.setState({ services_access });
    } catch (e) {
      this.setState({ services_access: {} });
    }
  };

  /**
   * Determina si un ítem del menú debe mostrarse al usuario.
   *
   * Reglas:
   * - Si el ítem no tiene service_id (Inicio, Membresías, Reportes, etc.) → siempre visible.
   * - Si el ítem tiene service_id:
   *     ACCESS_GRANTED (1) → visible y habilitado
   *     ACCESS_LIMITED (2) → visible pero deshabilitado (plan agotado este mes)
   *     ACCESS_DENIED  (3) → oculto (sin plan o sin cobertura)
   *     Sin registro      → oculto (el backend no lo incluyó = sin acceso)
   */
  canShowMenuItem = (item: MenuItem): boolean => {
    const isIternal = this.props.user?.internal === Constants.LAWYER_INTERNAL.YES;
    if (!item.service_id) return true;
    if (isIternal) return true;
    const access = this.state.services_access[item.service_id];
    // Mostrar si tiene acceso (GRANTED) o si agotó usos este mes (LIMITED)
    // Ocultar si está denegado o si no hay registro de acceso
    return (
      access === Constants.ACCES_STATUS.ACCESS_GRANTED ||
      access === Constants.ACCES_STATUS.ACCESS_LIMITED ||
      access === Constants.ACCES_STATUS.ACCESS_DENIED
    );
  };

  // ACCESS_GRANTED → habilitado; ACCESS_LIMITED y ACCESS_DENIED → deshabilitado
  isMenuItemEnabled = (item: MenuItem): boolean => {
    // Bloqueado manualmente (independiente de membresía/service_id)
    if (item.forceDisabled) return false;
    // Requiere membresía activa, salvo que el abogado sea interno
    const isInternal = this.props.user?.internal === Constants.LAWYER_INTERNAL.YES;
    if (item.requiresMembership && !isInternal && !this.props.plan_user) return false;
    if (isInternal && item.service_id) return true;
    if (!item.service_id) return !item.disabled;
    const access = this.state.services_access[item.service_id];
    return access === Constants.ACCES_STATUS.ACCESS_GRANTED;
  };

  // Mensaje de error contextual según el tipo de restricción de acceso
  getMenuItemAccessMessage = (item: MenuItem): string => {
    // Bloqueado manualmente (independiente de membresía/service_id)
    if (item.forceDisabled) {
      return 'Esta funcionalidad no está disponible por el momento';
    }
    // Requiere membresía activa, salvo que el abogado sea interno
    const isInternal = this.props.user?.internal === Constants.LAWYER_INTERNAL.YES;
    if (item.requiresMembership && !isInternal && !this.props.plan_user) {
      return `Para acceder a ${item.name} necesita una membresía activa. Adquiera o actualice su membresía.`;
    }

    if (!item.service_id) return '';
    const access = this.state.services_access[item.service_id];

    switch (access) {
      case Constants.ACCES_STATUS.ACCESS_LIMITED:
        return `Has alcanzado el límite de usos de ${item.name} para este mes. Puedes esperar al próximo mes o adquirir un paquete adicional de usos.`;
      case Constants.ACCES_STATUS.ACCESS_DENIED:
        return `${item.name} no está incluido en tu plan actual. Adquiere o mejora tu membresía para acceder a este servicio.`;
      default:
        return `No tienes acceso a ${item.name} en este momento.`;
    }
  };

  checkVerifyModal = () => {
    const { user, history } = this.props;
    const searchParams = new URLSearchParams(history.location.search);
    const showWelcome = searchParams.get('welcome') === 'true';

    if (
      user?.level_id === Constants.LEVELS.LAWYER &&
      user?.verified === Constants.VERIFIED.PENDING
    ) {
      if (showWelcome) {
        // Google Tag Manager - Evento de registro completado abogado
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'registro_completado_abogado' });
        this.setState({
          visibleWelcomeModal: true,
          visibleVerifyModal: false,
          visibleWelcomeClientModal: false,
        });
      } else {
        this.setState({
          visibleWelcomeModal: false,
          visibleVerifyModal: true,
          visibleWelcomeClientModal: false,
        });
      }
    } else if (
      user?.level_id === Constants.LEVELS.LAWYER &&
      (user?.verified === Constants.VERIFIED.IN_PROCESS ||
        user?.verified === Constants.VERIFIED.REJECTED)
    ) {
      this.setState({
        visibleVerifyModal: false,
        visibleWelcomeClientModal: false,
      });
    } else if (user?.level_id === Constants.LEVELS.CLIENT && showWelcome) {
      // Google Tag Manager - Evento de registro completado usuario
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'registro_completado_usuario' });
      this.setState({
        visibleWelcomeClientModal: true,
        visibleWelcomeModal: false,
        visibleVerifyModal: false,
      });
    } else {
      this.setState({
        visibleWelcomeModal: false,
        visibleVerifyModal: false,
        visibleWelcomeClientModal: false,
      });
    }
  };

  toggleSidebar = () => {
    let key: any = `leftOpen`;
    // @ts-ignore
    this.setState({ [key]: !this.state[key] }, () => {
      this.props.dispatch({
        type: 'SET_SIDEBAR',
        payload: this.state.leftOpen,
      });
    });
  };

  checkActive = (value: string, current: string) => {
    return current.includes(value);
  };

  changeMenu = (item: MenuItem) => {
    if (item.submenu && !this.state.leftOpen) {
      this.toggleSidebar();
    }
  };

  checkPermission = (item: any) => {
    if (this.props.user?.level_id == Constants.LEVELS.ADMIN) {
      return true;
    }
    const permissions =
      this.props.user?.module_permissions
        ?.filter((i: any) => i.read)
        .map((i: any) => i.module_id) || [];
    if (Array.isArray(item.permission)) {
      let _continue = false;
      item.permission.forEach((i: any) => {
        if (permissions.indexOf(i) != -1) {
          _continue = true;
        }
      });
      return _continue;
    } else {
      return permissions.indexOf(item.permission) != -1;
    }
  };

  closeNavbar = () => {
    // @ts-ignore
    $('#collapsibleNavbar').collapse('hide');
  };

  toggleResponsive = () => {
    this.setState({ openResponsive: !this.state.openResponsive });
  };

  closeResponsive = () => {
    this.setState({ openResponsive: !this.state.openResponsive });
  };

  handleLogout = () => {
    Globals.confirm('¿Desea cerrar sesión?', async () => {
      await performLogout();
      this.props.history.replace('/login');
      Globals.quitLoading();
    });
  };

  render() {
    let leftOpen = !this.props.isAuth && this.state.leftOpen ? 'open' : 'closed';
    let items = [];

    if (this.props.user) {
      switch (this.props.user?.level_id) {
        case Constants.LEVELS.ADMIN:
          items = this.state.items;
          break;

        case Constants.LEVELS.MODERATOR:
          items = this.state.items.filter((item: MenuItem) => item.code !== 'referrals');
          break;

        case Constants.LEVELS.CLIENT:
          items = this.state.items_clients;
          break;

        case Constants.LEVELS.LAWYER:
          const isInternal = this.props.user?.internal === Constants.LAWYER_INTERNAL.YES;
          items = this.state.items_lawyer.filter((item: MenuItem) => {
            if (item.path === '/lawyer/calls') return isInternal;
            if (item.path === '/lawyer/memberships') return !isInternal;
            return true;
          });
          break;
      }
    }

    return (
      <React.Fragment>
        <Modal
          className='modal-view-validate'
          visible={this.state.visibleWelcomeModal}
          title=''
          centered
          onClose={() => this.setState({ visibleWelcomeModal: false })}
        >
          <ModalWelcomeLawyer
            onClose={() => this.setState({ visibleWelcomeModal: false })}
            goToValidation={() => {
              this.setState({ visibleWelcomeModal: false });
              this.props.history.push('/lawyer/validation');
            }}
            userName={this.props.user?.name}
          />
        </Modal>

        <Modal
          className='modal-view-validate'
          visible={this.state.visibleVerifyModal}
          title=''
          centered
          onClose={() => this.setState({ visibleVerifyModal: false })}
        >
          <ModalViewValidate
            goToValidation={() => {
              this.setState({ visibleVerifyModal: false });
              this.props.history.push('/lawyer/validation');
            }}
            onClose={() => this.setState({ visibleVerifyModal: false })}
          />
        </Modal>

        <Modal
          className='modal-view-validate'
          visible={this.state.visibleWelcomeClientModal}
          title=''
          centered
          onClose={() => this.setState({ visibleWelcomeClientModal: false })}
        >
          <ModalWelcomeClient
            onClose={() => this.setState({ visibleWelcomeClientModal: false })}
            userName={this.props.user?.name}
          />
        </Modal>

        <div id='left' className={leftOpen}>
          <div
            className={`sidebar ${leftOpen + ' ' + (this.state.openResponsive ? 'open-responsive' : '')}`}
          >
            <div
              className={`shadow-close ${this.state.openResponsive ? 'open' : ''}`}
              onClick={this.closeResponsive}
            ></div>
            <div className='container-menu'>
              <div className={`menu ${leftOpen}`}>
                <div className='container-scroll'>
                  <ul className={leftOpen}>
                    {items.map((i: MenuItem, index: number) => {
                      const isAdminOrMod =
                        this.props.user?.level_id === Constants.LEVELS.ADMIN ||
                        this.props.user?.level_id === Constants.LEVELS.MODERATOR;

                      const enabled = isAdminOrMod || this.isMenuItemEnabled(i);
                      const access = i.service_id
                        ? this.state.services_access[i.service_id]
                        : undefined;
                      const isLimited = access === Constants.ACCES_STATUS.ACCESS_LIMITED;

                      return (
                        <React.Fragment key={index}>
                          {(!i.permission || this.checkPermission(i)) && (
                            <li
                              className={`nav-item ${this.checkActive(i.path, this.props.history.location.pathname) ? 'active' : ''} ${!enabled ? 'disabled' : ''} `}
                            >
                              <Link
                                to={i.path || '#'}
                                className={`${i.submenu && i.submenu.length > 0 ? 'contain-submenu' : ''}`}
                                onClick={(e: any) => {
                                  if (!enabled) {
                                    e.preventDefault();
                                    Globals.showError(this.getMenuItemAccessMessage(i));
                                    return;
                                  }

                                  if (i.onClick) {
                                    e.preventDefault();
                                    i.onClick();
                                  } else {
                                    if (
                                      i.submenu &&
                                      i.submenu.length > 0 &&
                                      this.checkActive(
                                        i.path,
                                        this.props.history.location.pathname,
                                      ) &&
                                      this.props.open_menu
                                    ) {
                                      this.props.dispatch({
                                        type: 'SET_OPEN_MENU',
                                        payload: false,
                                      });
                                      e.preventDefault();
                                    } else {
                                      this.props.dispatch({
                                        type: 'SET_OPEN_MENU',
                                        payload: true,
                                      });
                                      this.changeMenu(i);
                                      this.closeResponsive();
                                    }
                                  }
                                }}
                              >
                                <div
                                  className={`container-icon-menu ${leftOpen} ${this.checkActive(i.path, this.props.history.location.pathname) ? 'active' : ''}`}
                                >
                                  {i.icon && (
                                    <img
                                      src={
                                        this.checkActive(
                                          i.path,
                                          this.props.history.location.pathname,
                                        )
                                          ? i.iconActive
                                          : i.icon
                                      }
                                    />
                                  )}
                                </div>
                                <span className={leftOpen}>
                                  {i.name}
                                  {!enabled && (
                                    <img
                                      className='lock-icon-menu'
                                      src={LockIcon}
                                      alt='Bloqueado'
                                    />
                                  )}
                                  {i.submenu && i.submenu.length > 0 && (
                                    <React.Fragment>
                                      {this.checkActive(
                                        i.path,
                                        this.props.history.location.pathname,
                                      ) ? (
                                        <img
                                          className='arrow-drop'
                                          src={this.props.open_menu ? ArrowUp : ArrowBottom}
                                        />
                                      ) : (
                                        <img className='arrow-drop' src={ArrowBottom} />
                                      )}
                                    </React.Fragment>
                                  )}
                                </span>
                              </Link>
                              {this.props.open_menu && (
                                <div
                                  className={`${i.submenu && i.submenu.length > 0 && this.checkActive(i.path, this.props.history.location.pathname) ? 'container-submenu' : ''}`}
                                >
                                  {leftOpen != 'closed' &&
                                    this.checkActive(
                                      i.path,
                                      this.props.history.location.pathname,
                                    ) &&
                                    i.submenu &&
                                    i.submenu.map((item: MenuItem, index: number) => {
                                      if (!item.permission || this.checkPermission(item)) {
                                        return (
                                          <li
                                            key={index}
                                            className={
                                              'nav-item item-submenu ' +
                                              (this.props.history.location.pathname == item.path
                                                ? 'active'
                                                : '')
                                            }
                                          >
                                            <Link to={item.path} className='submenu'>
                                              {item.icon && <img src={item.icon} />}
                                              {item.name}
                                            </Link>
                                          </li>
                                        );
                                      }
                                    })}
                                </div>
                              )}
                            </li>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
            <div className={`container-router ${leftOpen}`}>
              <Header
                className={leftOpen + ' ' + (items.length > 0 && 'header-responsive')}
                toggleSidebar={() => this.toggleSidebar()}
                toggleResponsive={() => this.toggleResponsive()}
              />
              <div
                className={`container-padding-router ${items.length > 0 && 'container-responsive'}`}
              >
                {this.props.children}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default connect((state: any) => {
  return {
    user: state.user,
    open_menu: state.open_menu,
    sidebar: state.sidebar,
    plan_user: state.plan_user,
  };
})(Menu);
